var Student = "Pelajar/Mahasiswa";
var jobRole = {
	"Job role": "Jabatan",
	"Academic / Researcher": "Akademisi / Peneliti",
	"Advisor / Consultant": "Penasihat / Konsultan",
	"Business Executive": "Eksekutif Bisnis",
	"Developer / Engineer": "Developer / Teknisi",
	"Entrepreneur (Founder/Co-Founder)": "Wiraswasta (Pendiri/Rekan pendiri)",
	"IT Executive": "Eksekutif IT",
	"IT Professional or Technical Manager": "Profesional IT atau Manajer Teknis",
	"Press / Media Analyst": "Pers / Analis Media",
	"Sales / Marketing": "Penjualan/Pemasaran",
	Student: Student,
	"Solution or Systems Architect": "Arsitek Solusi atau Sistem",
	"System Administrator": "Administrator Sistem",
	"Venture Capitalist": "Kapitalis Ventura"
};

export { Student, jobRole as default };
